<template>
      
  <b-container>
    <b-row>
      <b-col class="p-3 text-left" v-if="section.section_type == 'equipment'">
        <b-btn variant="outline-primary" size="sm"  @click.prevent="openSidebar('roof-section-list')" class="p-0 px-2">
          <b-spinner v-if="loading" small label="Loading..."></b-spinner>
          <font-awesome-icon icon="arrow-left" />
          {{$t("menu.back")}}
        </b-btn>
      </b-col>
      <b-col class="p-3 text-right" v-if="section.section_type == 'equipment'">
        <b-btn variant="outline-primary" size="sm" @click.prevent="cloneSection()" class="p-0 px-2">
          <b-spinner v-if="loading" small label="Loading..."></b-spinner>
          <font-awesome-icon icon="copy" />
          {{$t("menu.copy")}}
        </b-btn>
      </b-col>
    </b-row>
    <b-row >
      <b-col class="pr-0">
          <b-row v-if="isEquipment" class="mb-3">
            <b-col>
              <b-form-group class="m-0" :label="this.$t('sidebar.heading.equipment')">
                {{equipment && $t('equipment_type.' + equipment.name)}}
              </b-form-group>
            </b-col>
            <b-col cols="auto">
              <img :src="equipmentIcon(section.equipment_detail.equipment_config.icon)" width="50" v-if="isEquipmentIcon"/>
            </b-col>
          </b-row>
          <b-row style="border-top:1px solid #aaa;padding:20px 0;">
            <b-col class="text-center" v-if="section.shape_type == 'polygon' || section.asset_type == 'roof'">
              <b-form-group class="m-0" :label="this.$t('sidebar.heading.area')">
                  <small><span class="text-info">{{section.area | round}} M<sup>2</sup></span></small>
              </b-form-group>
            </b-col>
            <b-col class="text-center" 
            v-if="section.section_type == 'roof'">
              <b-form-group class="m-0" :label="this.$t('sidebar.heading.net_area')">
                <small><span class="text-info">{{section.net_area | round}} M<sup>2</sup></span></small>
              </b-form-group>
            </b-col>
            <b-col class="text-center" 
            v-if="isEquipment && (section.equipment_config || {}).name === 'counter_cladding'">
              <b-form-group class="m-0" :label="this.$t('sidebar.heading.area')">
                <small><span class="text-info">{{section.area | round}} M<sup>2</sup></span></small>
              </b-form-group>
            </b-col>
            <b-col class="text-center" 
              v-if="section.shape_type == 'polygon' || section.shape_type == 'polyline' || section.asset_type == 'roof'">
              <b-form-group class="m-0" :label="(section.equipment_config || {}).name === 'counter_cladding'? $t('sidebar.heading.length') : $t('sidebar.heading.perimeter')">
                <small>
                  <span class="text-info">{{section.perimeter | round }} M</span>
                </small>
              </b-form-group>
            </b-col>
          </b-row>
      </b-col>
      <b-col cols="1">
        
      </b-col>
    </b-row>
    <b-row >
      <b-col class="pa-3 pb-1 text-center divider-legend-column">
        
          <b-badge pill class="divider-legend"> 
            {{this.$t("sidebar.heading.utilities")}}
          </b-badge>
        
      </b-col>
    </b-row>
    <b-row class="mt-2">
      <b-col cols="4" v-if="section.shape_type != 'marker'">
        <b-row>
          <b-col class="mb-2" cols="12">
            <strong>
             Rotate
            </strong>
          </b-col>
          <b-col cols="12">
            <a href="javascript://" class="btn btn-sm btn-primary mr-2" @click="rotate('left')">
              <font-awesome-icon icon="rotate-left" size="sm" />
            </a>
            <a href="javascript://" class="btn btn-sm btn-primary" @click="rotate('right')">
              <font-awesome-icon icon="rotate-right" size="sm"/>
            </a>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
    <b-row class="mb-3">
      <b-col v-if="isEquipment">
        <b-form-checkbox size="sm" v-model="draggable" name="check-button" button @change="changeDragEvent()" button-variant="outline-primary" class="mt-2">
          <span :class="{'text-white': draggable}"><font-awesome-icon :icon="['fas', 'up-down-left-right']" /> {{this.$t("sidebar.label.draggable")}} </span>
        </b-form-checkbox>
        
        <b-btn variant="primary"  class="ml-2" size="sm" @click="autoSetCoords()">
          {{this.$t("sidebar.label.auto_set_shape")}}
        </b-btn>
        
      </b-col>
    </b-row>
    <b-row >
      <b-col class="pa-3 pb-1 text-center divider-legend-column">
        
          <b-badge pill class="divider-legend"> 
            {{this.$t("menu.properties")}}
          </b-badge>
        
      </b-col>
    </b-row>
    <b-row>
      <b-col class="mt-2">
        <b-form-group :label="this.$t('sidebar.heading.label')">
          <b-form-input v-model="section.label" />
        </b-form-group>
      </b-col>
    </b-row>
    <b-row>
      <b-col class="">
        <b-form-group :label="this.$t('menu.assign_divlato_code')">
          <multiselect
            v-model="selectedDivaltoCodes"
            :options="divaltoCodes"
            :multiple="true"
            :searchable="true"
            @search-change="search"
            :placeholder="this.$t('sidebar.placeholder.search')"
            :custom-label="getResultValue"
            track-by="id">
          </multiselect>

<!--           <autocomplete :search="search"
              :get-result-value="getResultValue"
              @submit="onDivaltoCodeSubmit"
              :defaultValue="(section.divalto_code || {}).short_description"
              :key="'section-' + section.id"
              ></autocomplete> -->
        </b-form-group>
      </b-col>
    </b-row>
    <b-row v-if="isEquipment && equipment" class="" cols="2">
      <template v-for="field,index in sortedFieldsData">
        <b-col :key="`f-0-${index}`">
          <equipment-sub-fields :fields="fields" :index="index" :field="field" :section="section" />
        </b-col>
        <template v-for="subfield,subIndex in subfields(field,index)">
          <b-col :key="`f-1-${subIndex}`">
            <equipment-sub-fields :fields="fields" :index="subIndex" :field="subfield" :section="section" />
          </b-col>
          <template v-for="subSubfield,subSubIndex in subfields(subfield,subIndex)">
            <b-col :key="`f-2-${subSubIndex}`">
              <equipment-sub-fields :fields="fields" :index="subSubIndex" :field="subSubfield" :section="section" />
            </b-col>
          </template>
        </template>
      </template>
      
    </b-row>

    <b-row>
      <b-col>
        <b-btn variant="outline-dark rounded-lg" @click="closeSidebar()">ANNULER</b-btn>
        <b-btn 
          class="ml-2 rounded-lg" 
          variant="primary" :disabled="loading"
          @click="submitHandler()">
          
          UPDATE
          <b-spinner v-if="loading" small label="Loading..."></b-spinner>
        </b-btn>

        <b-btn variant="danger" class="float-right" @click="deleteEquipment()">
          <font-awesome-icon :icon="['fas', 'trash']" />
        </b-btn>
      </b-col>
    </b-row>
  </b-container>
</template>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<script>

import {ProjectMixin} from '@/mixins';
import { mapGetters, mapState } from 'vuex'
import EquipmentSubFields from '../EquipmentSubFields.vue';
import Multiselect from 'vue-multiselect'
import CesiumManager from '@/utils/CesiumManager';
export default {
  name: "SectionInfoDrawer",
  mixins: [ProjectMixin],
  props: ['copySection'],

  data(){
    return {
      loading: false,
      defaultFields: {},
      draggable: false,
      prevSectionId: null,
      selectedDivaltoCodes: []
    }
  },

  components:{
      EquipmentSubFields,
      Multiselect
  },

  mounted(){
  },

  computed: {
    ...mapState(['sections']),
    
    ...mapGetters({
      selectedShape: 'gmap/selectedShape',
      currentDrawingTool: 'sections/currentDrawingTool',
      currentEquipmentConfig: 'sections/currentEquipmentConfig',
      divaltoCodes: 'divaltoCodes/items',
      project: 'projects/item',
      copyData: 'sections/copyData'
    }),
    groups:{
        get(){
            return this.$store.getters['canvas/groups']
        },
        set(value){
            this.$store.commit('canvas/groups', value)
        }
    },
    section(){
      return (this.sections.item)
    },

    isEquipment(){
      return (this.section.section_type == 'equipment')
    },
    isEquipmentIcon(){
      return (this.section.section_type == 'equipment') && 
      this.section.equipment_detail && 
      this.section.equipment_detail.equipment_config
    },

    equipment(){
      return this.section.equipment_detail.equipment_config
    },

    fields(){
      if((this.section.equipment_detail || {}).data){
        return this.section.equipment_detail.data
      } else {
        return this.defaultFields
      }
    },
    sortedFieldsData() {
      if (!this.equipment || !this.equipment.fields_data) return [];
      const fieldsData = this.equipment.fields_data;
      const desiredOrder = ['length', 'width', 'nature'];
      const sortedEntries = Object.entries(fieldsData).sort(([keyA], [keyB]) => {
        const indexA = desiredOrder.indexOf(keyA);
        const indexB = desiredOrder.indexOf(keyB);
        if (indexA === -1) return 1;
        if (indexB === -1) return -1;
        return indexA - indexB;
      });
  return Object.fromEntries(sortedEntries);
},

  },
  
  watch: {
    section: function(val1, val2){
      if(val1.id != this.prevSectionId){
        this.draggable = false
      }
      this.prevSectionId = val1.id
      this.selectedDivaltoCodes = val1.divalto_codes
    }
  },
  
  methods: {
    search(input) {

      return new Promise((resolve) => {
        if (input.length < 2) {
          return resolve([])
        }

        this.$store.dispatch('divaltoCodes/all', { 
          config: { 
            params: { 
              filters: { 
                short_description_cont: input,
                element_code_cont: input,
                m: 'or'
              } 
            } 
          }   
        }).then((data) => {
            resolve(data.data)
          })
      })
    },

    equipmentIcon(icon){
      return require(`@/assets/equipment_icons/${icon}`);
    },

    submitHandler(){
      this.loading = true
      if(this.isEquipment){
        let equipmentDetail = {
          equipment_config: this.equipment,
          equipment_config_id: this.equipment.id,
          data: this.fields,
          id: (this.section.equipment_detail || {}).id
        }
        this.section.equipment_detail = equipmentDetail
        if (this.equipment.name === 'counter_cladding') {
          const length = parseFloat(this.section.perimeter) || 0
          const height = parseFloat(this.fields.height) || 0
          this.section.area = length * height
        }
      }
      this.section.divalto_code_ids = (this.selectedDivaltoCodes || []).map(c => c.id)
      console.log(this.section)
      if(this.section.id){
        this.updateSection()
      } else {
        this.createSection()
      }
    },

    createSection(){
      this.$store.dispatch('sections/create', {
        projectId: this.section.project_id,
        payload: {
          section: this.section
        },
        config: {
          params: {
            include: ['equipment_detail', 'equipment_detail.equipment_config']
          }
        }
      }).then((res)=>{
        this.$store.dispatch("gmap/setShapeOptions", { id: res.data.data.id })
        this.$store.dispatch('ui/projectSidebar.close')
      }).finally(()=>{
        this.loading = false
      })
    },

    updateSection(){
      this.$eventbus.$emit('section-update-roof-id')
      this.$store.dispatch('sections/update', {
        projectId: this.section.project_id,
        id: this.section.id,
        payload: {
          section: this.section
        },
        config: {
          params: {
            include: ['equipment_detail', 'equipment_detail.equipment_config']
          }
        },
      }).then(()=>{
        this.$store.dispatch('ui/projectSidebar.close')
      }).finally(()=>{
        this.loading = false
      })
    },

    subfields(field, index){
      if(index in this.fields && 'options' in field && !Array.isArray(field.options)){
        return (field.options[this.fields[index]] || {}).fields || []
      }else{
        return [];
      }            
    },

    getResultValue(result){
      return (`(${result.element_code}) ` + result.short_description)
    },

    onDivaltoCodeSubmit(result){
      this.section.divalto_code = result
      this.section.divalto_code_id = result.id
    },

    rotate(direction){
      if(this.project.asset_type == 'drone'){
        this.$store.dispatch("gmap/rotate", direction)
      }else{
        this.$store.dispatch("canvas/rotate", direction)
        this.updateSection()
      }
    },

    changeDragEvent(){
      if(this.project.asset_type == 'drone'){
        this.$store.dispatch("gmap/setShapeOptions", { draggable: this.draggable })
      }else{
        this.groups[this.section.id].obj.data = {
          options: {
            drag: this.draggable
          }
        }
        this.$store.commit('canvas/dragEquipId', this.draggable ? this.section.id : null)
        
      }
    },

    deleteEquipment(){
      if(confirm("Are you sure to delete Equipment?")){
        const { project_id, id, shape_type } = this.section;
        this.$store.dispatch("sections/delete", {
          projectId: project_id,
          id: id
        }).then(()=>{
          const layerManager = CesiumManager.getLayerManager()
          if(layerManager){
            const emitClick = (shape) => this.$eventbus.$emit('on3DShapeClick', shape);

            const shapeHandlers = {
              polygon: () => layerManager.removePolygonLayer(id, emitClick),
              polyline: () => layerManager.removePolylineLayer(id, emitClick),
              marker: () => layerManager.removeMarkerLayer(id, emitClick),
            };

            const handler = shapeHandlers[shape_type];
            if (handler) handler();
          }
          this.$store.dispatch('ui/projectSidebar.close')
      })
      }
    },

    autoSetCoords(){
      if(this.project.asset_type == 'drone'){
        this.$store.dispatch("gmap/autoSetCoordinates", this.section)
      }else{
        this.autoSetCoordinates()
      }
    },

    autoSetCoordinates(){
      this.$eventbus.$emit("section-autoset")
    },

    cloneSection(){
      this.$store.dispatch('sections/CURRENT_MODE', {})
      this.$store.dispatch('sections/setOrToggleCopyState', true)
      // const config = {
      //   params: {
      //     include: ['equipment_detail', 'equipment_detail.equipment_config']
      //   }
      // }
      
      // this.$store.dispatch("sections/copySection", {section: this.section, config: config}).then(resp => {
      //   if(typeof(this.copySection) == 'function'){
      //     this.copySection(resp.data.data)
      //   }
      // })
      console.log(this.initiateCopy)
      this.$store.dispatch('sections/setCopyData', {
        enabled:true, 
        section: this.section, 
        sectionShape: this.selectedShape,
        initiateCopy: this.initiateCopy
      })
    },

    initiateCopy(position){
      this.$store.dispatch('sections/copyDroneSection', {center: position }).then(resp => {
        if(typeof(this.copySection) == 'function'){
          this.copySection(resp.data.data)
        }
      })
    }
  }
  
}
</script>

